import { Grid, Stack, Text, Title } from '@mantine/core';
import moment from 'moment';

import { EORIGIN_DATE_FORMAT_WITH_TIME, Transit } from '@e-origin/shared';

interface RecoveryNotificationProps {
  transit: Transit;
}

export const RecoveryNotification: React.FC<RecoveryNotificationProps> = ({ transit }: RecoveryNotificationProps) => {
  return (
    <Stack gap="xl" mb="md">
      {transit.customsState.recoveryNotification && (
        <Stack gap="sm">
          <Title order={5} fw={600}>
            Recovery notification
          </Title>
          <Grid>
            <Grid.Col span={3}>
              <Stack gap="xs">
                <Text c="gray" size="sm">
                  Recovery notification date
                </Text>
                <Text fw={500}>{moment(transit.customsState.recoveryNotification.recoveryNotificationDate).format(EORIGIN_DATE_FORMAT_WITH_TIME)}</Text>
              </Stack>
            </Grid.Col>
            <Grid.Col span={3}>
              <Stack gap="xs">
                <Text c="gray" size="sm">
                  Recovery notification text
                </Text>
                <Text fw={500}>{transit.customsState.recoveryNotification.recoveryNotificationText}</Text>
              </Stack>
            </Grid.Col>
            <Grid.Col span={3}>
              <Stack gap="xs">
                <Text c="gray" size="sm">
                  Amount claimed
                </Text>
                <Text fw={500}>{transit.customsState.recoveryNotification.amountClaimed}</Text>
              </Stack>
            </Grid.Col>
            <Grid.Col span={3}>
              <Stack gap="xs">
                <Text c="gray" size="sm">
                  Currency
                </Text>
                <Text fw={500}>{transit.customsState.recoveryNotification.currency}</Text>
              </Stack>
            </Grid.Col>
          </Grid>
        </Stack>
      )}

      {transit.customsState.guarantor && (
        <Stack gap="sm">
          <Title order={5} fw={600}>
            Guarantor
          </Title>
          <Grid>
            <Grid.Col span={3}>
              <Stack gap="xs">
                <Text c="gray" size="sm">
                  Identification number
                </Text>
                <Text fw={500}>{transit.customsState.guarantor.identificationNumber}</Text>
              </Stack>
            </Grid.Col>
            <Grid.Col span={3}>
              <Stack gap="xs">
                <Text c="gray" size="sm">
                  Name
                </Text>
                <Text fw={500}>{transit.customsState.guarantor.name}</Text>
              </Stack>
            </Grid.Col>
          </Grid>
          {transit.customsState.guarantor.address && (
            <Stack gap="sm">
              <Title order={6}>Guarantor address</Title>
              <Grid>
                <Grid.Col span={3}>
                  <Stack gap="xs">
                    <Text c="gray" size="sm">
                      Street and number
                    </Text>
                    <Text fw={500}>{transit.customsState.guarantor.address.streetAndNumber}</Text>
                  </Stack>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Stack gap="xs">
                    <Text c="gray" size="sm">
                      Postcode
                    </Text>
                    <Text fw={500}>{transit.customsState.guarantor.address.postcode}</Text>
                  </Stack>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Stack gap="xs">
                    <Text c="gray" size="sm">
                      City
                    </Text>
                    <Text fw={500}>{transit.customsState.guarantor.address.city}</Text>
                  </Stack>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Stack gap="xs">
                    <Text c="gray" size="sm">
                      country
                    </Text>
                    <Text fw={500}>{transit.customsState.guarantor.address.country}</Text>
                  </Stack>
                </Grid.Col>
              </Grid>
            </Stack>
          )}
        </Stack>
      )}
    </Stack>
  );
};
